module.exports = __webpack_public_path__ + "static/media/allfresco-login.4f9322f4.jpg";